import React from "react"

const SearchBar = ({ searchTerm, onSearch, name, placeholder }) => (
    <span className="searchicon">
        <input
            type="search"
            placeholder={placeholder || "search"}
            name={name || "name"}
            className="form-control"
            value={searchTerm}
            onChange={onSearch}
            data-cy="searchBar"
        />
    </span>
)

export default SearchBar
